// extracted by mini-css-extract-plugin
export default {"column":"Column-module__column","title":"Column-module__title","list":"Column-module__list","more-genres":"Column-module__more-genres"};